import React from 'react'
import { useI18next, I18nextContext } from 'gatsby-plugin-react-i18next'

const LanguageSwitcher = () => {
  const { languages, changeLanguage } = useI18next()
  const context = React.useContext(I18nextContext)

  return (
    <ul className="language-switcher">
      {languages.map(lng => (
        <li key={lng} className={context.language === lng ? 'active' : ''}>
          <button
            onClick={e => {
              e.preventDefault()
              changeLanguage(lng)
            }}
          >
            {lng}
          </button>
        </li>
      ))}
    </ul>
  )
}

export default LanguageSwitcher
